import { APIService } from "../../../../../../network/api/APIService";


export const AccountActivationData = (formData) => {
  return APIService({
      endpoint: "/account/activation/",
      method: "POST",
      data: formData
  });
};